import maskPhoneNumber from '@lib/utils/maskPhoneNumber';
import {
  ActionMenu,
  BodyText,
  Button,
  Dialog,
  Icon,
  Stack,
} from '@servicetitan/design-system';
import styles from './MessageViewHeader.module.css';
import { useState } from 'react';
import strings from './strings';
import ToastModule from '@modules/ToastModule';

interface MessageViewHeaderProps {
  phoneNumber: string;
  customerName?: string;
  onEndSession?: () => void;
  onMarkAsUnread?: () => void;
  onMarkAsSpam?: () => void;
}

const MessageViewHeader = ({
  phoneNumber,
  customerName,
  onMarkAsUnread,
  onMarkAsSpam,
  onEndSession,
}: MessageViewHeaderProps) => {
  const [showMessageOptions, setShowMessageOptions] = useState(false);
  const [showBlockSpamDialog, setShowBlockSpamDialog] = useState(false);

  const handleBlockSpam = () => {
    setShowBlockSpamDialog(false);
    onMarkAsSpam?.();
    ToastModule.showToast({
      title: strings.labels.toasts.blockSpamSuccess,
      status: 'success',
    });
  };

  const handleEndSession = () => {
    onEndSession?.();
    ToastModule.showToast({
      title: strings.labels.toasts.endSessionSuccess,
      status: 'success',
    });
  };

  const handleMarkAsUnread = () => {
    onMarkAsUnread?.();
    setShowMessageOptions(false);
  };

  return (
    <>
      <div className={`p-3 bg-neutral-10 ${styles.messageHeaderContainer}`}>
        <Stack justifyContent='space-between' alignItems='center'>
          <Stack className={styles.customerInfoStack} direction='column'>
            <BodyText size='small'>{maskPhoneNumber(phoneNumber)}</BodyText>
            <BodyText
              className={`t-truncate ${styles.CustomerName}`}
              size='medium'
              bold
            >
              {customerName || strings.labels.unknownCustomer}
            </BodyText>
          </Stack>
          <div>
            <Stack spacing={1}>
              <Button color='negative' size='small' onClick={handleEndSession}>
                {strings.labels.endSessionButton}
              </Button>
              <ActionMenu
                width='auto'
                direction='bl'
                open={showMessageOptions}
                onClickOutside={() => setShowMessageOptions(false)}
                trigger={
                  <Button
                    onClick={() => setShowMessageOptions(true)}
                    icon={<Icon size={24} name='more_vert' />}
                    aria-label={strings.labels.messageOptionsButton}
                    fill='subtle'
                  />
                }
              >
                <ActionMenu.Item
                  icon='markunread_mailbox'
                  onClick={handleMarkAsUnread}
                >
                  <BodyText size='medium'>
                    {strings.labels.actionMenu.markAsUnread}
                  </BodyText>
                </ActionMenu.Item>
                <ActionMenu.Item
                  icon='error'
                  onClick={() => setShowBlockSpamDialog(true)}
                >
                  <BodyText size='medium'>
                    {strings.labels.actionMenu.blockSpam}
                  </BodyText>
                </ActionMenu.Item>
              </ActionMenu>
            </Stack>
          </div>
        </Stack>
      </div>
      <Dialog
        open={showBlockSpamDialog}
        focusTrapOptions={{ disabled: true }}
        title={strings.labels.blockSpamDialog.title}
        portal={true}
        onPrimaryActionClick={() => handleBlockSpam()}
        primaryActionName={strings.labels.blockSpamDialog.primaryAction}
        onSecondaryActionClick={() => setShowBlockSpamDialog(false)}
        secondaryActionName={strings.labels.blockSpamDialog.secondaryAction}
        negative
      >
        {strings.labels.blockSpamDialog.body}
      </Dialog>
    </>
  );
};

export default MessageViewHeader;
